import {
  CHAT_CATEGORIES,
  CHAT_REDUCER_ACTIONS,
  FILTER_ACTIVE_CHAT,
  FILTER_STATE_CHAT,
  FILTER_STATUS_CHAT,
  FILTER_TYPE_CHAT,
} from "../constants/chats.const";
import { publish } from "../utils/events";

const isConversationInFilter = (conversation, filter, category) => {
  const {
    type,
    chatId,
    username,
    endDate,
    initDate,
    channel,
    state,
    status,
    active,
    labels,
    keyword,
    origin,
  } = filter;
  const {
    type: chatType,
    sender_id: senderId,
    user_name: chatUsername,
    date_last_message: chatDate,
    channel: chatChannel,
    assign_user: assignUser,
    answered,
    open,
    live,
    labels: chatLabels,
    state: chatCategory,
    origin: chatOrigin,
  } = conversation;
  if (keyword !== "") return false;
  if (
    (category === CHAT_CATEGORIES.CHATS &&
      chatCategory !== 0 &&
      chatCategory !== 1) ||
    (category === CHAT_CATEGORIES.ARCHIVE && chatCategory !== 2)
  )
    return false;

  if (
    (type === FILTER_TYPE_CHAT.CONTACT_REQUESTS &&
      chatType !== "live" &&
      chatType !== "request") ||
    (type === FILTER_TYPE_CHAT.BOT_CHATS && chatType !== "bot") ||
    (type === FILTER_TYPE_CHAT.LIVE_CHATS && chatType !== "live")
  )
    return false;

  if (username && !chatUsername.toLowerCase().includes(username.toLowerCase()))
    return false;
  if (chatId && !senderId.includes(chatId)) return false;

  if (initDate && endDate) {
    const [day, month, year] = chatDate.split(" ")[0].split("/");
    const formattedDate = `${year}-${month}-${day}`;
    if (formattedDate < initDate || formattedDate > endDate) return false;
  }

  if (channel && chatChannel !== channel.toLowerCase()) return false;

  if (
    (state === FILTER_STATE_CHAT.ASSIGNED && !assignUser) ||
    (state === FILTER_STATE_CHAT.UNASSIGNED && assignUser)
  )
    return false;

  if (
    (status === FILTER_STATUS_CHAT.READ && !open) ||
    (status === FILTER_STATUS_CHAT.UNREAD && open)
    // (status === FILTER_STATUS_CHAT.ANSWERED && !answered)
  )
    return false;

  if (
    (active === FILTER_ACTIVE_CHAT.ACTIVE && !live) ||
    (active === FILTER_ACTIVE_CHAT.INACTIVE && live)
  )
    return false;

  if (origin && origin !== "all" && chatOrigin !== origin) return false;

  if (labels.length > 0 && !labels.every((cl) => chatLabels.includes(cl)))
    return false;
  return true;
};

const sortChats = (chats) => {
  return chats.sort((a, b) => {
    const [dayA, monthA, yearA, timeA] = a.date_last_message.split(/\/| /);
    const [hourA, minuteA] = timeA.split(":");
    const dateA = new Date(yearA, monthA - 1, dayA, hourA, minuteA);

    const [dayB, monthB, yearB, timeB] = b.date_last_message.split(/\/| /);
    const [hourB, minuteB] = timeB.split(":");
    const dateB = new Date(yearB, monthB - 1, dayB, hourB, minuteB);
    return dateB - dateA;
  });
};

const decrementCounter = (value) => Math.max(0, Number(value || 0) - 1);
const normalizeMessageType = (value) =>
  typeof value === "string" ? value.toLowerCase() : value;
const normalizeMessageValue = (value) =>
  typeof value === "string" ? value.trim() : value;
const normalizeTargetMessageId = (value) => value ?? null;
const isArchivedState = (conversationState) => {
  if (conversationState === null || conversationState === undefined) {
    return false;
  }

  const normalizedState = String(conversationState).toLowerCase();
  return normalizedState === "2" || normalizedState === CHAT_CATEGORIES.ARCHIVE;
};

export const chatReducer = (state, action) => {
  const { payload } = action;
  switch (action.type) {
    case CHAT_REDUCER_ACTIONS.SET_CHAT:
      return {
        ...state,
        chat: {
          userInfo: payload.userInfo,
          chatInfo: payload.chatInfo,
          messages: payload.messages,
        },
      };
    case CHAT_REDUCER_ACTIONS.UPDATE_CHAT_INFO:
      return {
        ...state,
        chat: {
          ...state.chat,
          chatInfo: { ...state.chat.chatInfo, ...payload },
        },
      };
    case CHAT_REDUCER_ACTIONS.UPDATE_USER_INFO:
      return {
        ...state,
        chat: {
          ...state.chat,
          userInfo: { ...state.chat.userInfo, ...payload },
        },
      };
    case CHAT_REDUCER_ACTIONS.SET_CHATS:
      return {
        ...state,
        chats: {
          data: payload.data,
          page: payload.page,
          totalPages: payload.totalPages,
          total: payload.total,
          currentChatsCount: payload.currentChatsCount,
          archivedChatsCount: payload.archivedChatsCount,
        },
      };
    case CHAT_REDUCER_ACTIONS.ADD_NEW_CHAT: {
      let _chats = [...state.chats.data];
      let total = state.chats.total;
      let _currentChatsCount = state.chats.currentChatsCount;
      let _archivedChatsCount = state.chats.archivedChatsCount;
      if (
        isConversationInFilter(payload, state.filterSelected, state.category)
      ) {
        const index = _chats.findIndex((x) => x.id === payload.id);
        const isNewChat = index === -1;

        if (isNewChat) {
          _chats.length >= 20 && _chats.pop();
        } else {
          _chats.splice(index, 1);
        }

        _chats.unshift(payload);

        if (isNewChat) {
          total += 1;
          _currentChatsCount += 1;
        }
        if (
          (!state.chatInfo?.id || state.chatInfo?.id === payload?.id) &&
          (!payload?.messageFrom || payload.messageFrom === "user")
        ) {
          publish("notification", {
            name: "Trini Talkbot",
            body: "Nuevo Mensaje",
            tag: "new-message",
          });
        }
      }
      return {
        ...state,
        chats: {
          ...state.chats,
          data: _chats,
          total: total,
          currentChatsCount: _currentChatsCount,
          archivedChatsCount: _archivedChatsCount,
        },
      };
    }

    case CHAT_REDUCER_ACTIONS.ADD_NEW_MESSAGE: {
      const incomingMessage = {
        ...payload.message,
        username: payload?.message?.user_name,
      };

      const existingIndex = state.chat.messages.findIndex((msg) => {
        const sameByChannelMessageId =
          msg?.message_id &&
          incomingMessage?.message_id &&
          msg.message_id === incomingMessage.message_id;

        const sameByInternalId =
          msg?.id && incomingMessage?.id && msg.id === incomingMessage.id;

        return sameByChannelMessageId || sameByInternalId;
      });

      if (existingIndex !== -1) {
        const mergedMessages = [...state.chat.messages];
        mergedMessages[existingIndex] = {
          ...mergedMessages[existingIndex],
          ...incomingMessage,
          optimistic: false,
        };

        return {
          ...state,
          chat: {
            ...state.chat,
            chatInfo: { ...state.chat.chatInfo, open: false },
            messages: mergedMessages,
          },
        };
      }

      const optimisticIndex = state.chat.messages.findIndex((msg) => {
        return (
          msg?.optimistic === true &&
          normalizeMessageType(msg?.type) ===
          normalizeMessageType(incomingMessage?.type) &&
          normalizeMessageValue(msg?.value) ===
          normalizeMessageValue(incomingMessage?.value) &&
          normalizeTargetMessageId(msg?.target_message_id) ===
          normalizeTargetMessageId(incomingMessage?.target_message_id)
        );
      });

      if (optimisticIndex !== -1) {
        const reconciledMessages = [...state.chat.messages];
        reconciledMessages[optimisticIndex] = {
          ...reconciledMessages[optimisticIndex],
          ...incomingMessage,
          optimistic: false,
        };
        return {
          ...state,
          chat: {
            ...state.chat,
            chatInfo: { ...state.chat.chatInfo, open: false },
            messages: reconciledMessages,
          },
        };
      }

      return {
        ...state,
        chat: {
          ...state.chat,
          chatInfo: { ...state.chat.chatInfo, open: false },
          messages: [...state.chat.messages, incomingMessage],
        },
      };
    }
    case CHAT_REDUCER_ACTIONS.ADD_OPTIMISTIC_MESSAGE: {
      return {
        ...state,
        chat: {
          ...state.chat,
          messages: [...state.chat.messages, payload.message],
        },
      };
    }
    case CHAT_REDUCER_ACTIONS.UPDATE_OPTIMISTIC_MESSAGE: {
      const updatedMessages = state.chat.messages.map((msg) => {
        if (msg.id !== payload.message_id) {
          return msg;
        }

        return { ...msg, ...payload.data };
      });

      return {
        ...state,
        chat: {
          ...state.chat,
          messages: updatedMessages,
        },
      };
    }
    case CHAT_REDUCER_ACTIONS.UPDATE_MESSAGE: {
      let _messages = [...state.chat.messages];
      const index = _messages.findIndex(
        (x) =>
          x.message_id === payload.message_id ||
          x.id === payload.message_id
      );

      if (index !== -1) {
        _messages[index] = { ..._messages[index], ...payload.data };
      }

      return {
        ...state,
        chat: {
          ...state.chat,
          messages: _messages,
        },
      };
    }
    case CHAT_REDUCER_ACTIONS.UPDATE_MESSAGE_STATUS: {
      let _messages = [...state.chat.messages];
      const index = _messages.findIndex(
        (x) =>
          x.message_id === payload.message_id ||
          x.id === payload.message_id
      );

      if (index !== -1) {
        _messages[index] = {
          ..._messages[index],
          ...payload.message_status_obj,
        };
      }

      return {
        ...state,
        chat: {
          ...state.chat,
          messages: _messages,
        },
      };
    }
    case CHAT_REDUCER_ACTIONS.UPDATE_CHAT_IN_MENU: {
      let _chats = [...state.chats.data];
      const index = _chats.findIndex((x) => x.id === payload.id);
      if (index !== -1) {
        _chats[index] = { ..._chats[index], ...payload };
        _chats = sortChats(_chats);
      }
      return {
        ...state,
        chats: {
          ...state.chats,
          data: _chats,
        },
      };
    }
    case CHAT_REDUCER_ACTIONS.UPDATE_FILTER_CHATS_IN_MENU: {
      let _chats = [...state.chats.data];
      let total = state.chats.total;
      let _currentChatsCount = state.chats.currentChatsCount;
      let _archivedChatsCount = state.chats.archivedChatsCount;

      const existingIndex = _chats.findIndex((x) => x.id === payload.id);
      const previousChat = existingIndex !== -1 ? _chats[existingIndex] : null;

      if (previousChat?.state !== undefined && previousChat?.state !== payload?.state) {
        const wasArchived = isArchivedState(previousChat.state);
        const isArchived = isArchivedState(payload.state);

        if (wasArchived !== isArchived) {
          if (isArchived) {
            _currentChatsCount = decrementCounter(_currentChatsCount);
            _archivedChatsCount += 1;
          } else {
            _archivedChatsCount = decrementCounter(_archivedChatsCount);
            _currentChatsCount += 1;
          }
        }
      }

      if (
        isConversationInFilter(payload, state.filterSelected, state.category)
      ) {
        const index = existingIndex;
        if (index === -1) {
          _chats.length >= 20 && _chats.pop();
          _chats.unshift(payload);
          total += 1;
        } else {
          _chats[index] = { ..._chats[index], ...payload };
        }
        _chats = sortChats(_chats);
      } else {
        const index = _chats.findIndex((x) => x.id === payload.id);
        if (index !== -1) {
          _chats.splice(index, 1);
          total -= 1;
        }
      }
      return {
        ...state,
        chats: {
          ...state.chats,
          data: _chats,
          total: total,
          currentChatsCount: _currentChatsCount,
          archivedChatsCount: _archivedChatsCount,
        },
      };
    }
    case CHAT_REDUCER_ACTIONS.DELETE_CHAT_IN_MENU: {
      let _chats = [...state.chats.data];
      const index = _chats.findIndex((x) => x.id === payload.id);
      const shouldRemove = index !== -1;
      if (shouldRemove) {
        _chats.splice(index, 1);
      }

      let _currentChatsCount = state.chats.currentChatsCount;
      let _archivedChatsCount = state.chats.archivedChatsCount;

      if (shouldRemove) {
        if (state.category === "resueltas") {
          _archivedChatsCount = decrementCounter(_archivedChatsCount);
        } else {
          _currentChatsCount = decrementCounter(_currentChatsCount);
        }
      } else {
        _currentChatsCount = Math.max(0, _currentChatsCount);
        _archivedChatsCount = Math.max(0, _archivedChatsCount);
      }

      return {
        ...state,
        chats: {
          ...state.chats,
          data: _chats,
          total: shouldRemove ? Math.max(0, state.chats.total - 1) : state.chats.total,
          currentChatsCount: _currentChatsCount,
          archivedChatsCount: _archivedChatsCount,
        },
      };
    }
    case CHAT_REDUCER_ACTIONS.CLEAR_CHAT:
      return {
        ...state,
        chat: { messages: [], chatInfo: null, userInfo: null },
      };
    case CHAT_REDUCER_ACTIONS.CHANGE_CATEGORY:
      return {
        ...state,
        category: payload.category,
      };
    case CHAT_REDUCER_ACTIONS.SET_FILTER_SELECTED:
      return {
        ...state,
        filterSelected: { ...state.filterSelected, ...payload },
      };
    case CHAT_REDUCER_ACTIONS.SET_LOADING:
      return {
        ...state,
        loading: { ...state.loading, ...payload },
      };
    case CHAT_REDUCER_ACTIONS.SET_AREAS_AND_CONTACTS:
      return {
        ...state,
        areas: payload.areas,
        contacts: payload.contacts,
      };
    case CHAT_REDUCER_ACTIONS.SET_ACTIONS_LABELS:
      return {
        ...state,
        actions_labels: payload.labels_actions
      };

    case CHAT_REDUCER_ACTIONS.SET_CONTACTS_GROUPS:
      return {
        ...state,
        contacts_groups: payload.contacts_groups
      };

    // case CHAT_REDUCER_ACTIONS.ADD_NEW_CONTACT: {
    //   if (!payload?.value) return state;
    //   const currentContacts = state.allContacts ?? [];
    //   const exists = currentContacts.some((c) => c.value === payload.value);
    //   return {
    //     ...state,
    //     allContacts: exists
    //       ? currentContacts.map((c) => (c.value === payload.value ? payload : c))
    //       : [...currentContacts, payload],
    //   };
    // }

    case CHAT_REDUCER_ACTIONS.OPEN_MOBILE_TAB:
      return { ...state, mobileTab: true };
    case CHAT_REDUCER_ACTIONS.CLOSE_MOBILE_TAB:
      return {
        ...state,
        mobileTab: false,
        chat: { messages: [], chatInfo: null, userInfo: null },
      };
    case CHAT_REDUCER_ACTIONS.CHANGE_DIALOG:
      if (payload?.dialog === "labels" || payload?.dialog === "quickReplies") {
        return {
          ...state,
          dialogs: {
            ...state.dialogs,
            [payload?.dialog]: {
              active: payload?.active,
              tab: payload?.tab,
            },
          },
        };
      }
      return {
        ...state,
        dialogs: { ...state.dialogs, [payload]: !state.dialogs[payload] },
      };
    case CHAT_REDUCER_ACTIONS.SET_LABELS:
      return {
        ...state,
        labels: payload,
      };
    // En chatReducer.js
    case CHAT_REDUCER_ACTIONS.SET_LEAD_QUALITY_SCORE:
      return {
        ...state,
        chat: {
          ...state.chat,
          chatInfo: {
            ...state.chat.chatInfo,
            lead_score: payload,
          },
        },
        chats: {
          ...state.chats,
          data: state.chats.data.map((c) =>
            c.id === state.chat.chatInfo?.id
              ? { ...c, lead_score: payload }
              : c
          ),
        },
      };
    case CHAT_REDUCER_ACTIONS.SET_CLOSED_CHAT: {
      const chatId = payload?.id ?? state.chat.chatInfo?.id;
      const isSelectedChat = state.chat.chatInfo?.id === chatId;
      return {
        ...state,
        chat: {
          ...state.chat,
          userInfo: isSelectedChat
            ? { ...state.chat.userInfo, is_closed: true }
            : state.chat.userInfo,
        },
        chats: {
          ...state.chats,
          data: state.chats.data.map((c) =>
            c.id === chatId
              ? { ...c, is_closed: true }
              : c
          ),
        },
      };
    }
    case CHAT_REDUCER_ACTIONS.SET_QUICK_REPLIES:
      return {
        ...state,
        quickReplies: payload,
      };
    case CHAT_REDUCER_ACTIONS.CHANGE_DISABLED_BUTTONS:
      return {
        ...state,
        disabledButtons: !state.disabledButtons,
      };
    case CHAT_REDUCER_ACTIONS.INIT_STATES:
      return { ...state, ...payload };
  }
  return state;
};
